import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-slate-50 border-t border-slate-200 pt-16 pb-8">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand Info */}
          <div>
            <div className="mb-4 inline-block">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/b3858647681825aecd68df56d8217cb5094538977d896e84f508e759d2eeedf7b0dda9d7934361b5765cf6718803dd25/images/aW1hZ2UvcG5n/34b46cb221730d0e79867cbaafd25717.png" 
                alt="Kittsteiner Hoch-Tiefbau GmbH Logo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-slate-600 mb-4 max-w-sm">Ihr zuverlässiger Partner für Hoch-, Tief- und Pflasterbau in Pleinfeld und Umgebung.</p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-slate-900 mb-4 uppercase tracking-wider text-sm">Kontakt</h4>
            <ul className="space-y-3 text-slate-600">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiMapPin} className="mt-1 text-red-800" />
                <span>Bachstraße 7<br />91785 Pleinfeld / Mischelbach</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="text-red-800" />
                <a href="tel:015174465832" className="hover:text-red-800 transition-colors">0151 / 744 658 32</a>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="text-red-800" />
                <a href="mailto:Info@Kittsteiner-Bau.de" className="hover:text-red-800 transition-colors">Info@Kittsteiner-Bau.de</a>
              </li>
            </ul>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-slate-900 mb-4 uppercase tracking-wider text-sm">Rechtliches</h4>
            <ul className="space-y-2 text-slate-600">
              <li>
                <Link to="/impressum" className="hover:text-red-800 transition-colors">Impressum</Link>
              </li>
              <li>
                <Link to="/datenschutz" className="hover:text-red-800 transition-colors">Datenschutz</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-200 pt-8 flex flex-col items-center justify-center text-sm text-slate-500">
          <p>© {new Date().getFullYear()} Kittsteiner Hoch-Tiefbau GmbH. Alle Rechte vorbehalten.</p>
          <a 
            href="https://lima-service.de" 
            target="_blank" 
            rel="noopener noreferrer"
            className="mt-2 hover:text-red-800 transition-colors font-medium"
          >
            Powered by LIMA-Service.de
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;